import { Box, Button, Checkbox, FormControl, FormControlLabel, FormGroup, Grid, InputLabel, MenuItem, Modal, Select, Typography } from '@mui/material';
import React, { useState } from 'react';
import { fields } from './data';


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    maxHeight: '80vh',
    overflow: 'auto'
};


const NodeDetailSelectorModal = ({ handleClose, open, handleCloseModalSubmit }) => {
 

    const [selectedFields, setSelectedFields] = useState(
        fields.reduce((acc, field) => ({ ...acc, [field.id]: false }), {})
    );

    const [selectedExportType, setSelectedExportType] = useState("");



    const [childModalOpen, setChildModalOpen] = useState(false);

    const handleChildModalClose = () => {
        setChildModalOpen(false);
    };

    const handleSubmit = () => {

        const isAnyFieldSelected = Object.values(selectedFields).some(value => value === true);

        if (!isAnyFieldSelected) {
            return;
        }
        setChildModalOpen(true);
    };
    // console.log(selectedFields, "Selected Fields")
    // console.log(selectedExportType)

    const handleFieldCheckboxChange = (fieldName, checked) => {
        setSelectedFields((prev) => ({
            ...prev,
            [fieldName]: checked,
        }));
    };

    const handleSelectAllChange = (checked) => {
        const newFieldsState = fields.reduce(
            (acc, field) => ({ ...acc, [field.id]: checked }),
            {}
        );
        setSelectedFields(newFieldsState);
    };

    const handleSubmitClose = () => {
        if (!selectedExportType) return;
        // console.log("Selected Fields:", selectedFields);
        // console.log("Selected Export Type:", selectedExportType);
        handleCloseModalSubmit(selectedFields, selectedExportType);
        handleChildModalClose()
        handleClose()
    };



    const truncateStyle = {
        whiteSpace: 'nowrap',
        width: '300px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    };

    return (
        <>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" sx={{ mb: 2 }} variant="h6" component="h2">
                        Select Specific Fields To Export2
                    </Typography>
                    <Box gap={3} display="flex" sx={{ mb: "20px" }} alignItems="center" >
                        <Checkbox
                            sx={{ padding: "0px" }}
                            checked={Object.values(selectedFields).every((val) => val)}
                            onChange={(e) => handleSelectAllChange(e.target.checked)}
                        />
                        <Typography id="modal-modal-title" variant="h6" component="h3">
                            Select All
                        </Typography>
                    </Box>
                    <FormGroup>
                        {fields?.map((field, index) => (
                            <FormControlLabel
                                key={index}
                                control={
                                    <Checkbox
                                        checked={selectedFields[field.id]}
                                        onChange={(e) =>
                                            handleFieldCheckboxChange(
                                                field.id,
                                                e.target.checked
                                            )
                                        }
                                    />
                                }
                                label={<Typography sx={truncateStyle}>{field.label  }</Typography>}
                            />
                        ))}
                    </FormGroup>
                    <Grid my={2} item xs={12}>
                        <Button
                            variant="contained"
                            color="primary"
                            fullWidth
                            onClick={handleSubmit}
                        >
                            Submit
                        </Button>
                    </Grid>
                    <Grid item xs={12}>
                        <Button
                            onClick={handleClose}
                            variant="outlined"
                            fullWidth
                        >
                            Cancel
                        </Button>
                    </Grid>
                </Box>
            </Modal>
            <Modal
                open={childModalOpen}
                onClose={handleChildModalClose}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
            >
                <Box sx={{ ...style, width: 300 }}>
                    <h4 id="child-modal-title">Export As</h4>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Export As</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Export As"
                            value={selectedExportType}
                            onChange={(e) => setSelectedExportType(e.target.value)}
                        >
                            <MenuItem value="PDF">PDF</MenuItem>
                            <MenuItem value="Excel">Excel</MenuItem>
                        </Select>
                    </FormControl>
                    <Grid my={2} item xs={12}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSubmitClose}
                            fullWidth
                        >
                            Generate
                        </Button>
                    </Grid>
                    <Grid item xs={12}>
                        <Button
                            onClick={handleChildModalClose}
                            variant="outlined"
                            fullWidth
                        >
                            Cancel
                        </Button>
                    </Grid>
                </Box>
            </Modal>
        </>
    );
};

export default NodeDetailSelectorModal;
